import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=8e5144e0&scoped=true&"
import script from "./CustomerSearch.vue?vue&type=script&lang=js&"
export * from "./CustomerSearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=8e5144e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5144e0",
  null
  
)

export default component.exports